
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 152.57 106.56"}, attrs),
              ...rest,
            },
            children.concat([_c('defs'),_c('g',{attrs:{"id":"Layer_2","data-name":"Layer 2"}},[_c('g',{attrs:{"id":"SMART"}},[_c('path',{staticClass:"cls-1",attrs:{"d":"M13.42 53.26a2.66 2.66 0 102.65 2.66 2.66 2.66 0 00-2.65-2.66z"}}),_c('path',{staticClass:"cls-1",attrs:{"d":"M140.58 0H12A12 12 0 000 12v82.57a12 12 0 0012 12h128.58a12 12 0 0012-12V12a12 12 0 00-12-12zM13.42 60.93a5 5 0 115-5 5 5 0 01-5 5zM142 94.57a1.39 1.39 0 01-1.42 1.43H21.46V10.62h119.12A1.39 1.39 0 01142 12z"}}),_c('path',{staticClass:"cls-1",attrs:{"d":"M82.15 27.54a1.18 1.18 0 00-1.66.21L62.71 50.66 51 36.11a1.2 1.2 0 00-.84-.44 1.15 1.15 0 00-.89.32l-16 14.92a1.17 1.17 0 101.61 1.71l15-14.06 11.88 14.7a1.17 1.17 0 00.92.39 1.14 1.14 0 00.92-.41l18.7-24a1.19 1.19 0 00-.15-1.7z"}}),_c('path',{staticClass:"cls-1",attrs:{"d":"M132.34 45.68H87.58V21.89a1.38 1.38 0 00-1.38-1.38H29a1.37 1.37 0 00-1.37 1.38v37.47A1.37 1.37 0 0029 60.73h44.8v27.19a1.38 1.38 0 001.38 1.38h57.16a1.37 1.37 0 001.37-1.38V47.05a1.37 1.37 0 00-1.37-1.37zM30.42 58V23.26h54.41v22.42h-9.65a1.37 1.37 0 00-1.38 1.37V58zM81 54.84V58h-4.45v-9.57h8.28v6.41zm50 31.71H76.55V60.73h49.1v-5.89H87.58v-6.41H131z"}}),_c('path',{staticClass:"cls-1",attrs:{"d":"M81.43 65.4a1.18 1.18 0 100 2.36h43.43a1.18 1.18 0 100-2.36zM124.86 71.88H81.43a1.18 1.18 0 000 2.36h43.43a1.18 1.18 0 000-2.36zM124.86 78.38H81.43a1.18 1.18 0 000 2.36h43.43a1.18 1.18 0 000-2.36z"}})])])])
          )
        }
      }
    